import {api} from "@/api";

// 获取网关历史列表 
export const getList = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/gateway/pageUp',
        method: 'POST',
        data: data
    })
}

